import React, { useState, useEffect, useCallback } from 'react';
import { scrollToSection } from '../../utils/scrollToSection';
import './Hero.css';

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  
  const heroImages = [
    { src: '/images/banner/hero1.webp', alt: 'Professional roofing installation - Expert roof replacement by RC Roofing' },
    { src: '/images/banner/hero2.webp', alt: 'Quality siding installation - Premium exterior renovation services' },
    { src: '/images/banner/hero3.webp', alt: 'Complete home exterior renovation - Roofing, siding, and windows by RC Roofing' },
    { src: '/images/banner/hero4.webp', alt: 'Expert window and door installation - Energy-efficient home improvements' },
    { src: '/images/banner/hero5.webp', alt: 'Professional roofing repair and maintenance - Protecting your home investment' },
    { src: '/images/banner/hero6.webp', alt: 'Full exterior home makeover - Complete roofing and siding transformation' }
  ];

  const nextImage = useCallback(() => {
    setCurrentImage((prevImage) => (prevImage + 1) % heroImages.length);
  }, [heroImages.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      nextImage();
    }, 4000); // Change image every 4 seconds
    return () => {
      clearInterval(interval);
    };
  }, [nextImage, currentImage, heroImages.length]);

  // Scroll event listener to hide/show powered-by tag
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 50); // Hide tag when scrolled more than 50px
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <section id="home" className="hero">
      <div className="hero-background">
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentImage ? 'active' : ''}`}
            style={{ 
              backgroundImage: `url(${image.src})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
            role="img"
            aria-label={index === currentImage ? image.alt : undefined}
            aria-hidden={index !== currentImage}
          />
        ))}
        <div className="hero-overlay"></div>
      </div>
      
      
      {/* Powered by tag */}
      <div className={`powered-by-tag ${isScrolled ? 'scrolled' : ''}`}>
        Powered by: <a href="https://rcremodel.com" target="_blank" rel="noopener noreferrer" className="company-name">RC Remodel</a>
      </div>

      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title max-width-430">
              Residential or Commercial Roof,&nbsp;
              <span className="highlight"> RC Roofing</span>&nbsp;experts are here to help.
            </h1>
            <p className="hero-description">
              Expert roofing, siding, windows, and exterior renovation services. 
              From roof replacements to complete home exteriors, we deliver 
              superior craftsmanship and lasting protection for your property.
            </p>
            <div className="hero-buttons">
              <button className="btn btn-primary" onClick={() => scrollToSection('contact')}>
                Get Free Quote
              </button>
              <button className="btn btn-outline" onClick={() => scrollToSection('portfolio')}>
                View Our Work
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
